const LOCAL_HOSTNAMES = new Set(['127.0.0.1', 'localhost']);
const FRONTEND_DEV_PORT = '3001';
const BACKEND_DEV_PORT = '3000';

function getCurrentLocation() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.location;
}

function getApiBaseUrl() {
  const location = getCurrentLocation();

  if (!location) {
    return '';
  }

  if (LOCAL_HOSTNAMES.has(location.hostname) && location.port === FRONTEND_DEV_PORT) {
    return `${location.protocol}//${location.hostname}:${BACKEND_DEV_PORT}`;
  }

  return '';
}

export function toApiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
}

export function apiFetch(path, options) {
  return fetch(toApiUrl(path), options);
}

export function sendApiBeacon(path, payload, contentType = 'application/json') {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') {
    return false;
  }

  const body = payload instanceof Blob ? payload : new Blob([payload], { type: contentType });
  return navigator.sendBeacon(toApiUrl(path), body);
}
